import { Outlet, RouteObject } from 'react-router'
import { OrgChartInfoProvider } from '@/pages/organization-chart/useOrgChartInfo.tsx'
import { lazy } from 'react'

const OrgChartPage = lazy(() => import('@/pages/organization-chart/organization-chart-main.tsx'))


export const organizationChartRoutes: RouteObject = {
  path: 'organization-chart',
  element: <Outlet />,
  children: [
    { index: true, element: <OrgChartInfoProvider><OrgChartPage /></OrgChartInfoProvider> },
  ],
}